import { z } from 'src/lib'
import { EntityWithIdAndDescription, EntityWithIdAndDescriptionFields } from 'src/types'
import { getEndpointCache } from './httpWRC'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

// TODO: tener un archivo con algunos esquemas armados: (paginacion con generico, entities cache, user, etc, para extenderlas desde los endpoints)
const schema = z.array(
    z.object({
        [EntityWithIdAndDescriptionFields.Id]: z.number(),
        [EntityWithIdAndDescriptionFields.Description]: z.string()
    })
)

export const getExcepcionesPorTipo = (codOperacionWRCTipo: number): Promise<EntityWithIdAndDescription[]> => {
    const endpoint = getEndpointCache(`tipos/${codOperacionWRCTipo}/excepciones`)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                return Promise.reject('Error de validación.')
            }

            return Promise.resolve(parsed.data)
        })
        .catch(() => {
            return Promise.reject('Error de red.')
        })
}
